/**
 * Source: ClientApp2/src/theme/Typography.tsx — Montserrat + custom scale.
 * Adapted for v4: no `declare module '@mui/material/Typography'` (that augmentation is v5-only).
 * Custom variants (bodysemibold, bodynormal, btnmedium...) stay as plain data; theme-fleet
 * components consume them via makeStyles.
 */
const typography: any = {
  fontFamily: "'Montserrat', sans-serif",
  fontSize: 14,
  h1: {
    fontFamily: 'Montserrat',
    fontSize: '2.25rem',
    fontWeight: 600,
    lineHeight: '2.7rem',
    letterSpacing: '-0.045rem'
  },
  h2: {
    fontFamily: 'Montserrat',
    fontSize: '1.875rem',
    fontWeight: 600,
    lineHeight: '2.25rem',
    letterSpacing: '-0.01875rem'
  },
  h3: { fontFamily: 'Montserrat', fontSize: '1.5rem', fontWeight: 600, lineHeight: '1.8rem' },
  h4: {
    fontFamily: 'Montserrat',
    fontSize: '1.3125rem',
    fontWeight: 600,
    lineHeight: '1.70625rem'
  },
  h5: { fontFamily: 'Montserrat', fontSize: '1.125rem', fontWeight: 600, lineHeight: '1.35rem' },
  h6: { fontFamily: 'Montserrat', fontSize: '1rem', fontWeight: 600, lineHeight: '1.2rem' },
  button: { textTransform: 'capitalize', fontWeight: 400 },
  bodybig: {
    fontFamily: 'Montserrat',
    fontSize: '1rem',
    fontWeight: 400,
    lineHeight: '1.4rem',
    letterSpacing: '-0.02rem'
  },
  bodynormal: {
    fontFamily: 'Montserrat',
    fontSize: '0.875rem',
    fontWeight: 400,
    lineHeight: '1.225rem',
    letterSpacing: '-0.0175rem'
  },
  bodysemibold: {
    fontFamily: 'Montserrat',
    fontSize: '0.875rem',
    fontWeight: 600,
    lineHeight: '1.225rem',
    letterSpacing: '-0.00875rem'
  },
  bodysmall: {
    fontFamily: 'Montserrat',
    fontSize: '0.75rem',
    fontWeight: 400,
    lineHeight: '1.225rem'
  },
  bodysmallsemibold: {
    fontFamily: 'Montserrat',
    fontSize: '0.75rem',
    fontWeight: 600,
    lineHeight: '1.05rem'
  },
  body1: { fontSize: '0.875rem', fontWeight: 400, lineHeight: '1.334rem' },
  body2: { fontSize: '0.75rem', fontWeight: 400, lineHeight: '1rem', letterSpacing: '0rem' },
  subtitle1: { fontSize: '0.875rem', fontWeight: 400 },
  subtitle2: { fontSize: '0.875rem', fontWeight: 400 },
  caption: { fontSize: '0.75rem' }
};

export default typography;
